import React from 'react';
import HybridLink from './Links/HybridLink';
import { LazyHybridImage } from './HybridImage';

export interface BannerProps {
    className?: string;
    trackingFn: () => void;
    targetUrl?: string;
    altText?: string;
    mobileImage: string;
    desktopImage: string;
    shouldLazyLoadBanner?: boolean;
    trackImpressionFunction?: Function;
}

const Banner: React.FC<BannerProps> = ({
    className,
    trackImpressionFunction,
    shouldLazyLoadBanner = false,
    ...banner
}) => {
    if (!banner.targetUrl) {
        return (
            <LazyHybridImage
                className={className}
                desktopSrc={banner.desktopImage}
                mobileSrc={banner.mobileImage}
                alt={banner.altText}
                fallbackSrc={banner.desktopImage}
                shouldBeEagerlyLoaded={!shouldLazyLoadBanner}
                trackImpressionFunction={trackImpressionFunction}
            />
        );
    }

    return (
        <HybridLink className={className} to={banner.targetUrl} data-testid="anchor-link" onClick={banner.trackingFn}>
            <LazyHybridImage
                desktopSrc={banner.desktopImage}
                mobileSrc={banner.mobileImage}
                alt={banner.altText}
                fallbackSrc={banner.desktopImage}
                shouldBeEagerlyLoaded={!shouldLazyLoadBanner}
                trackImpressionFunction={trackImpressionFunction}
            />
        </HybridLink>
    );
};

export default Banner;
